import { alertAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(alertAnatomy.keys);

const graceful = definePartsStyle({
  container: {
    marginBottom: '50px',
    border: '1px solid',
    borderColor: 'blackAlpha.300',
    background: 'white',
    _dark: {
      borderColor: 'blackAlpha.600',
      background: 'blackAlpha.800',
    },
  },
  title: {
    color: 'blackAlpha.900',
    _dark: {
      color: 'white',
    },
  },
  description: {
    fontSize: 'sm',
  },
});

export const Alert = defineMultiStyleConfig({
  variants: { graceful },
});
